(function(window) { var svs = window.svs || {}; svs.modules = svs.modules || []; if(svs.modules.indexOf('/modules/spelpaus-react/views/react-container.js') >= 0) return;  svs.modules.push('/modules/spelpaus-react/views/react-container.js');
(function(svs, Handlebars) {
_svs=window.svs=window.svs||{};
_svs.spelpaus_react=_svs.spelpaus_react||{};
_svs.spelpaus_react.templates=_svs.spelpaus_react.templates||{};
svs.spelpaus_react.templates.react_container = Handlebars.template({"compiler":[8,">= 4.3.0"],"main":function(container,depth0,helpers,partials,data) {
    return "<div class=\"f-body bg-white js-react-container\"></div>";
},"useData":true});
Handlebars.partials['svs-spelpaus_react-react_container'] = svs.spelpaus_react.templates.react_container;
})(svs, Handlebars);


 })(window);